"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _MdCheck = require("@react-icons/all-files/md/MdCheck");

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _SelectionBox = require("./SelectionBox.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SelectionBox = function SelectionBox(_ref) {
  var children = _ref.children,
      className = _ref.className,
      enabled = _ref.enabled,
      isSelected = _ref.isSelected,
      onClick = _ref.onClick;
  var clickHandler = (0, _react.useCallback)(function () {
    return enabled && onClick();
  }, [enabled, onClick]);
  return /*#__PURE__*/_react["default"].createElement(_SelectionBox.StyledSelectionBox, {
    className: className,
    "data-selected": isSelected,
    enabled: enabled,
    onClick: clickHandler,
    selected: isSelected
  }, isSelected && /*#__PURE__*/_react["default"].createElement(_SelectionBox.StyledSelectionBoxSelectedWrapper, null, /*#__PURE__*/_react["default"].createElement(_SelectionBox.StyledSelectionBoxSelected, null, /*#__PURE__*/_react["default"].createElement(_MdCheck.MdCheck, null))), children);
};

SelectionBox.defaultProps = {
  children: undefined,
  className: undefined,
  enabled: true,
  isSelected: false,
  onClick: function onClick() {
    return null;
  }
};
SelectionBox.propTypes = {
  /** Selection Box content. */
  children: _propTypes.node,

  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** Enables or disables the selection box */
  enabled: _propTypes.bool,

  /** Sets the state of the selection box */
  isSelected: _propTypes.bool,

  /** Action to be called upon click */
  onClick: _propTypes.func
};
SelectionBox.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SelectionBox",
  "props": {
    "children": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Selection Box content.",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "enabled": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Enables or disables the selection box",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "isSelected": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Sets the state of the selection box",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onClick": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "description": "Action to be called upon click",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};
var _default = SelectionBox;
exports["default"] = _default;